(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-contour-lines", [], factory);
	else if(typeof exports === 'object')
		exports["map-contour-lines"] = factory();
	else
		root["map-contour-lines"] = factory();
})(self, function() {
return 